import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout_test}>
            <img src={content.poster.points} alt="东北超积分榜" />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
